import api from "./api";

interface GeneratePasswordOptions {
  length: number;
  lowercase: boolean;
  uppercase: boolean;
  numbers: boolean;
  symbols: boolean;
}

export const generatorService = {
  async generate(options: GeneratePasswordOptions): Promise<{ password: string }> {
    const response = await api.post("/password-generator", options);
    return response.data;
  },
};
